<template>
  <div style="height: 100%">
    <!--温湿度-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;margin-bottom: 10px;" v-if="!label">
        <span
          style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>平均温湿度</span>
    </div>

    <div v-if="tempHumidityData == null">
      <no-data style="margin-top: 20%;"></no-data>
    </div>
    <el-row style="padding-top: 30px;display: flex;" v-else>
      <div style="flex:1;display: flex;flex-direction: row;justify-content: center;align-items: center;">
        <div style="margin-right: 4px;">
          <img
          src="../../assets/images/index/temperature.png">
          </div>
          <div>
            <div class="temperature" style="color: rgba(16, 142, 233, 1);font-size: 1.4rem;">
              {{ tempHumidityData.tempAvg ? tempHumidityData.tempAvg : '-' }}℃
            </div>
            <div style="font-size: 0.9rem">机房温度</div>
          </div>
      </div>
      <div style="flex:1;display: flex;flex-direction: row;justify-content: center;align-items: center;">
        <div style="margin-right: 4px;">
          <img
          src="../../assets/images/index/humidity.png">
          </div>
          <div>
            <div class="humidity" style="color: #32CFD2;font-size: 1.4rem;">
              {{ tempHumidityData.humiAvg ? tempHumidityData.humiAvg : '-' }}%RH
            </div>
            <div style="font-size: 0.9rem">机房湿度</div>
          </div>
      </div>
      <div style="flex:1;display: flex;flex-direction: row;justify-content: center;align-items: center;">
        <div style="margin-right: 4px;">
          <img
          style="width: 27px;"
          src="../../assets/images/index/dewPoint.png">
          </div>
          <div>
            <div class="humidity" style="color: #00CFAC;font-size: 1.4rem;">
              {{ tempHumidityData.dewPoint != null && !isNaN(Number(tempHumidityData.dewPoint)) ? Number(tempHumidityData.dewPoint).toFixed(1) : '-' }}℃
            </div>
            <div style="font-size: 0.9rem">机房露点</div>
          </div>
      </div>

      <!-- <el-col :span="12">
        <el-col :span="12" style="text-align: right;padding-right: 8px;margin-top: 0.8vh;"><img
          src="../../assets/images/index/temperature.png"></el-col>
        <el-col :span="12">
          <div class="temperature" style="color: rgba(16, 142, 233, 1);font-size: 1.4rem;">
            {{ tempHumidityData.tempAvg ? tempHumidityData.tempAvg : '-' }}℃
          </div>
          <div style="font-size: 0.9rem">机房温度</div>
        </el-col>
      </el-col>
      <el-col :span="12">
        <el-col :lg="4" :md="6" :sm="6" :xs="4" style="text-align: left;margin-top: 1.5vh;"><img
          src="../../assets/images/index/humidity.png"></el-col>
        <el-col :span="12">
          <div class="humidity" style="color: #32CFD2;font-size: 1.4rem;">
            {{ tempHumidityData.humiAvg ? tempHumidityData.humiAvg : '-' }}%
          </div>
          <div style="font-size: 0.9rem">机房湿度</div>
        </el-col>
      </el-col> -->
    </el-row>
    <!--温湿度趋势-->
    <el-row style="height: 60%">
      <label style="margin-top: 20px;font-weight: bold;margin-left: 10%;" v-if="label">温湿度趋势</label>
      <line-chart :data="tempHumidityData.tempHumidityTrendData" :extend-data="extendData" ref="lineChart"
                  v-if="tempHumidityData.tempHumidityTrendData"
                  style="height: 95%"></line-chart>
      <no-data style="text-align: center;margin-top: 25%" v-else></no-data>
    </el-row>
    <div style="font-size: 0.9rem;font-weight: bold;width: 100%;text-align: center" v-if="!label">温湿度趋势</div>
  </div>
</template>

<script>
import LineChart from "@/components/echarts/LineChart";
import {getTemperatureAndHumidity} from "@/network/measuring-point-history";
import NoData from "@/components/NoData";

export default {
  name: "TemperatureHumidity",
  components: {LineChart, NoData},
  props: {
    label: {
      type: Boolean,
      default: true
    },
    extendData: null,
    spaceId: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      tempHumidityData: {}
    };
  },
  watch: {
    spaceId: {
      handler() {
        this.getData();
      }
    }
  },
  created() {
    this.getData();
    this.$store.dispatch('addIntervalObj', {'getTemperatureHumidity:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getTemperatureHumidity')
  },
  methods: {
    getData() {
      getTemperatureAndHumidity(this.spaceId).then(res => {
        if (res.code === 0) {
          if (res.data != null && res.data.length > 0) {
            const tempHumidityTrendData = {};
            tempHumidityTrendData.humidity = res.data[0].humidity;
            tempHumidityTrendData.temperature = res.data[0].temperature;
            tempHumidityTrendData.time = res.data[0].time;
            res.data[0].tempHumidityTrendData = tempHumidityTrendData;
            this.tempHumidityData = res.data[0];
          } else {
            this.tempHumidityData = {}
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
